/**
 * @fileOverview This file contains the implementation of the MoreInfoDialog component for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region  Imports
import {
  Popover,
  Grid,
  Typography,
  List,
  ListItem,
  Box,
} from '@mui/material';

import '../../scss/Components/Inventory/_infodialog.scss';
//#endregion

const MoreInfoDialog = ({ open, anchor, close }) => {
  return (
    <Popover
      id="inventory-popover"
      open={open}
      sx={{
        pointerEvents: 'none',
      }}
      anchorEl={anchor}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={close}
      disableRestoreFocus
    >
      <Grid className="dialog-container" container padding={1.5}>
        <Grid>
          <Typography className="legend-title">Prioridad</Typography>
          <List dense={true}>
            <ListItem disableGutters sx={{ gap: 2 }}>
              <Box
                sx={{
                  width: '55px',
                  height: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#F8463B',
                }}
              ></Box>
              <Typography className="legend-label">Prioridad 0</Typography>
            </ListItem>
            <ListItem disableGutters sx={{ gap: 2 }}>
              <Box
                sx={{
                  width: '55px',
                  height: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#FC842D',
                }}
              ></Box>
              <Typography className="legend-label">Prioridad 1</Typography>
            </ListItem>
            <ListItem disableGutters sx={{ gap: 2 }}>
              <Box
                sx={{
                  width: '55px',
                  height: '10px',
                  borderRadius: '10px',
                  backgroundColor: '#FFD850',
                }}
              ></Box>
              <Typography className="legend-label">Prioridad 2</Typography>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default MoreInfoDialog;
